var $ = require('lib/bling');
var isMobile = require('lib/isMobile');
var isWithinRadius = require('lib/isWithinRadius');
var reduce = require('lodash/reduce');
var requestAnimationFrame = require('lib/requestAnimationFrame');

// .....................
// === Chain Class ===
// ^^^^^^^^^^^^^^^^^^^^^
var Chain = function({el, minimumLinkDistance}) {
	this.$el = $(el);
	this.minimumLinkDistance = minimumLinkDistance;
	this.initialize();
};

Chain.prototype = {
	path: [],
	isAnimating: false,

	getPathString(pathArray) {
		return reduce(pathArray, (pathString, [x, y], i) => {
			if (i === 0) { pathString += 'M'; }
			return pathString + `${x} ${y} `;
		}, '');
	},

	getChainPath([mouseX, mouseY], pathArray) {
		var lastPoint = pathArray[pathArray.length - 1] || [];
		var lastX = lastPoint[0];
		var lastY = lastPoint[1];

		if (pathArray.length === 0 || !isWithinRadius(mouseX, mouseY, lastX, lastY, this.minimumLinkDistance)) {
			pathArray.push([mouseX, mouseY]);
		}

		if (pathArray.length > 1000) {
			pathArray.shift();
		}

		return pathArray;
	},

	drawLine([x, y]) {
		this.path = this.getChainPath([x, y], this.path);
		this.$el[0].setAttribute('d', `${this.getPathString(this.path)}`);
	},

	requestUpdate(e) {
		if (this.isAnimating) { return; }
		this.isAnimating = true;

		requestAnimationFrame(() => {
			this.drawLine([e.pageX, e.pageY]);
			this.isAnimating = false;
		});
	},

	initialize() {
		window.on('mousemove', this.requestUpdate.bind(this));
	}
};

module.exports = Chain;


// WEBPACK FOOTER //
// ./src/chain.js